/* The Tiny Toddlers redesign: homepage behaviour (launch carousel, car seat finder). No dependencies. */
(function () {
  'use strict';

  // ---------- Launch carousel: tabs in the rail are the slide navigation; each active tab fills over 6s ----------
  function initLaunch(root) {
    var board = root.querySelector('.t-lh');
    var track = root.querySelector('.t-lh-track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.t-lh-slide'));
    var tabsBox = root.querySelector('.t-lh-tabs');
    if (!board || !track || !slides.length) return;
    if (slides.length === 1) { board.classList.add('t-solo'); return; }
    var current = 0, timer = null, playing = true, DELAY = 6000, firstTurn = true; /* first slide stays 12 s: page settles before the hero moves */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tabsBox.innerHTML = slides.map(function (s, i) {
      return '<button type="button" class="t-lh-tab" data-i="' + i + '" aria-current="' + (i === 0) + '">' +
        '<span class="t-lh-num">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<span><small>' + (s.dataset.label || '') + '</small><b>' + (s.dataset.tab || '') + '</b></span>' +
        '<span class="t-lh-prog" aria-hidden="true"><i></i></span></button>';
    }).join('');
    var tabs = Array.prototype.slice.call(tabsBox.querySelectorAll('.t-lh-tab'));

    function show(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * current) + '%)';
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k !== current); s.inert = k !== current; });
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === current);
        var bar = t.querySelector('.t-lh-prog i');
        if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      var cb = tabs[current] && tabs[current].querySelector('.t-lh-prog i');
      if (cb) cb.style.animationDuration = firstTurn ? '12s' : '';
      if (playing && !reduce) { timer = setTimeout(function () { show(current + 1); }, firstTurn ? 12000 : DELAY); firstTurn = false; }
    }
    function setPlaying(p) {
      playing = p;
      board.classList.toggle('t-playing', p && !reduce);
      var btn = root.querySelector('[data-lh="play"]');
      if (btn) btn.setAttribute('aria-label', p ? 'Pause slides' : 'Play slides');
      schedule();
    }
    tabsBox.addEventListener('click', function (e) {
      var t = e.target.closest('.t-lh-tab'); if (t) show(+t.dataset.i);
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lh]'); if (!b) return;
      if (b.dataset.lh === 'prev') show(current - 1);
      if (b.dataset.lh === 'next') show(current + 1);
      if (b.dataset.lh === 'play') setPlaying(!playing);
    });
    board.addEventListener('mouseenter', function () { board.classList.add('t-hold'); clearTimeout(timer); });
    board.addEventListener('mouseleave', function () { board.classList.remove('t-hold'); schedule(); });
    board.addEventListener('focusin', function () { clearTimeout(timer); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
    });
    setPlaying(true);
    show(0);
  }

  // ---------- Car seat finder: filters the car seat collection by child size and must-haves ----------
  var SIZE_TYPES = {
    nb: ['group 0+/1', 'group 0+', 'group 0+/1/2/3', 'group 0', 'infant'],
    td: ['group 0+/1', 'group 1/2/3', 'group 0+/1/2/3', 'group 1'],
    ch: ['group 2/3', 'group 1/2/3', 'booster seat (15-36kg)', 'group 0+/1/2/3']
  };
  var NEEDS = {
    isize: /i-?size|r129/i,
    isofix: /isofix|i-?fix|isofit/i,
    rotate: /360|rotat|swivel|spin|turn/i
  };
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initFinder(root) {
    var dataEl = root.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var seats = []; try { seats = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var list = root.querySelector('[data-finder="list"]');
    var count = root.querySelector('[data-finder="count"]');
    var max = +(root.dataset.max || 5);
    var state = { size: (root.querySelector('.t-opt[aria-pressed="true"]') || {}).dataset ? root.querySelector('.t-opt[aria-pressed="true"]').dataset.size : 'td', needs: {} };

    function match(s) {
      var type = (s.type || '').toLowerCase();
      if (state.size && SIZE_TYPES[state.size].indexOf(type) === -1) return false;
      var hay = s.title + ' ' + (s.tags || []).join(' ');
      for (var k in state.needs) if (state.needs[k] && !NEEDS[k].test(hay)) return false;
      return true;
    }
    function render() {
      var hits = seats.filter(match);
      var shown = hits.slice(0, max);
      count.textContent = hits.length === 1 ? '1 seat fits' : hits.length + ' seats fit';
      if (!shown.length) {
        list.innerHTML = '<p class="t-res-empty">No seat matches every choice. Try removing one must-have, or email us and we\'ll help.</p>';
        return;
      }
      list.innerHTML = shown.map(function (s) {
        var sale = s.compare && s.compare > s.price;
        return '<a class="t-seat" href="' + esc(s.url) + '">' +
          '<span class="t-seat-th">' + (s.img ? '<img src="' + esc(s.img) + '" alt="" loading="lazy" width="72" height="72" style="width:100%;height:100%;object-fit:contain">' : '') + '</span>' +
          '<span class="t-seat-info"><span class="t-item-brand">' + esc(s.vendor) + '</span><strong>' + esc(s.title) + '</strong>' +
          '<small>' + (s.available ? (s.preorder ? 'Available to order' : 'In stock') : 'Out of stock') + '</small></span>' +
          '<span class="t-seat-price"><b' + (sale ? '' : ' style="color:var(--ink)"') + '>' + money(s.price, root.dataset.money) + '</b>' +
          (sale ? '<s>' + money(s.compare, root.dataset.money) + '</s>' : '') + '</span></a>';
      }).join('');
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('.t-opt');
      if (o) {
        root.querySelectorAll('.t-opt').forEach(function (b) { b.setAttribute('aria-pressed', b === o); });
        state.size = o.dataset.size; render(); return;
      }
      var t = e.target.closest('.t-tog');
      if (t) {
        var on = t.getAttribute('aria-pressed') !== 'true';
        t.setAttribute('aria-pressed', on); state.needs[t.dataset.need] = on; render();
      }
    });
    render();
  }

  // ---------- Quick add from product cards: AJAX cart, then let Stiletto refresh and open its cart ----------
  // After a successful add the button turns into "Go to basket" (customers asked how to reach the basket).
  function toGo(b) { b.classList.add('t-go'); b.dataset.tGo = '1'; b.removeAttribute('aria-pressed'); b.disabled = false; b.innerHTML = '<span>✓ Added · Go to basket</span>'; }
  function goCart() { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t-add]'); if (!b) return;
    e.preventDefault();
    if (b.dataset.tGo) { goCart(); return; }
    var label = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [b.dataset.tDispatch ? { id: +b.dataset.tAdd, quantity: 1, properties: { Dispatch: b.dataset.tDispatch } } : { id: +b.dataset.tAdd, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        toGo(b);
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        document.dispatchEvent(new CustomEvent('t:added'));
      })
      .catch(function (err) {
        b.textContent = (err && err.description) ? 'Not available' : 'Try again'; b.disabled = false;
        setTimeout(function () { b.textContent = label; }, 2500);
      });
  });


  // ---------- Collection cards (Stiletto product-item quick add): same flow as above, our own AJAX add so the button can become "Go to basket" ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-shop-trigger="quick-add"]'); if (!b || !b.dataset.productId) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.dataset.tGo) { goCart(); return; }
    var html = b.innerHTML; b.disabled = true; b.classList.add('loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.productId, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        b.classList.remove('loading');
        if (b.classList.contains('product-item__hoverless-quick-view-button')) { b.dataset.tGo = '1'; b.disabled = false; b.title = 'Go to basket'; b.classList.add('t-go'); }
        else toGo(b);
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        document.dispatchEvent(new CustomEvent('t:added'));
      })
      .catch(function (err) {
        b.classList.remove('loading'); b.disabled = false;
        b.innerHTML = '<span>' + ((err && err.description) ? 'Not available' : 'Try again') + '</span>';
        setTimeout(function () { b.innerHTML = html; }, 2500);
      });
  }, true);

  // ---------- Announcement bar: live dispatch countdown + rotation on narrow screens ----------
  function dispatchText() {
    var p = {};
    try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); } catch (e) { return null; }
    var h = parseInt(p.hour, 10) % 24, m = parseInt(p.minute, 10), left = 12 * 60 - (h * 60 + m);
    var working = ['Sat', 'Sun'].indexOf(p.weekday) === -1;
    return working && left > 0 ? 'Order within <b>' + Math.floor(left / 60) + 'h ' + (left % 60) + 'm</b> for same-day dispatch' : 'Order now for dispatch the next working day';
  }
  function initAnn(root) {
    function tick() { var t = dispatchText(); if (t) root.querySelectorAll('[data-t-dispatch]').forEach(function (el) { el.innerHTML = t; }); }
    tick(); setInterval(tick, 30000);
    var items = root.querySelectorAll('.t-ann-item'), i = 0;
    if (items.length > 1) setInterval(function () {
      if (window.innerWidth >= 1200) return;
      items[i].classList.remove('t-on'); i = (i + 1) % items.length; items[i].classList.add('t-on');
    }, 4000);
  }

  // ---------- Header: drop panels, shrink on scroll ----------
  function initHeader(root) {
    function openDrop(name) {
      ['stages', 'search', 'menu'].forEach(function (n) {
        var el = root.querySelector('#t-drop' + n.charAt(0).toUpperCase() + n.slice(1)); if (!el) return;
        var open = n === name && el.hidden; el.hidden = !open;
        root.querySelectorAll('[data-drop="' + n + '"]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
        if (open && n === 'search') { var q = el.querySelector('input[type=search]'); if (q) q.focus(); }
      });
    }
    root.addEventListener('click', function (e) { var d = e.target.closest('[data-drop]'); if (d) { e.preventDefault(); openDrop(d.dataset.drop); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) openDrop(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrop(null); });
    // Footer (or any) link to #t-journey opens the header stage picker instead of scrolling down the homepage
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="#t-journey"]'); if (!a || root.contains(a)) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();   // Stiletto page transitions would navigate otherwise
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () { var el = root.querySelector('#t-dropStages'); if (el && el.hidden) openDrop('stages'); }, 450);
    }, true);
    var top = root.querySelector('.t-top');
    window.addEventListener('scroll', function () { if (top) top.classList.toggle('t-small', window.scrollY > 40); }, { passive: true });
  }
  function refreshCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-t-count]').forEach(function (el) { el.textContent = c.item_count; el.classList.remove('t-bump'); void el.offsetWidth; el.classList.add('t-bump'); });
      document.querySelectorAll('[data-t-basket]').forEach(function (el) { el.setAttribute('aria-label', 'Basket, ' + c.item_count + (c.item_count === 1 ? ' item' : ' items')); });
    }).catch(function () {});
  }
  document.addEventListener('t:added', refreshCount);

  // ---------- Shop by stage ----------
  function initStages(root) {
    var stops = root.querySelectorAll('.t-stop'), panels = root.querySelectorAll('[data-panel]');
    var store = {}; try { store = JSON.parse(localStorage.getItem('ttt-kit') || '{}'); } catch (e) {}
    function progress(panel) {
      var ticks = panel.querySelectorAll('.t-tick'), done = 0;
      ticks.forEach(function (t) { var on = !!store[t.dataset.key]; t.setAttribute('aria-pressed', on); t.closest('li').classList.toggle('t-li-done', on); if (on) done++; });
      var p = panel.querySelector('[data-t-progress]'), b = panel.querySelector('[data-t-bar]');
      if (p) p.textContent = done + ' of ' + ticks.length + ' sorted';
      if (b) b.style.width = (ticks.length ? 100 * done / ticks.length : 0) + '%';
    }
    function show(i) {
      stops.forEach(function (s, k) { s.setAttribute('aria-pressed', k === i); });
      panels.forEach(function (p, k) { p.hidden = k !== i; if (k === i) progress(p); });
    }
    root.addEventListener('click', function (e) {
      var s = e.target.closest('.t-stop'); if (s) { show(+s.dataset.i); return; }
      var t = e.target.closest('.t-tick'); if (t) { store[t.dataset.key] = !store[t.dataset.key]; try { localStorage.setItem('ttt-kit', JSON.stringify(store)); } catch (err) {} progress(t.closest('[data-panel]')); }
    });
    var m = location.search.match(/[?&]stage=(\d)/);
    var start = m ? +m[1] : Array.prototype.findIndex.call(stops, function (s) { return s.getAttribute('aria-pressed') === 'true'; });
    show(start < 0 ? 0 : Math.min(start, stops.length - 1));
  }

  // ---------- Videos: YouTube loads only on play ----------
  function initVideo(root) {
    var player = root.querySelector('[data-t-player]'), chaps = root.querySelectorAll('.t-chap'), cur = chaps[0];
    function select(c, play) {
      cur = c; chaps.forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
      var t = root.querySelector('[data-t-vtitle]'); if (t) t.textContent = c.dataset.title;
      var img = root.querySelector('[data-t-vimg]'); if (img && c.dataset.img) img.src = c.dataset.img;
      var l = root.querySelector('[data-t-vlink]'); if (l && c.dataset.url) l.href = c.dataset.url;
      var pr = root.querySelector('[data-t-vprod]'); if (pr && c.dataset.prod) pr.innerHTML = '<span class="t-item-brand" style="display:block">Featured in this film</span><strong>' + esc(c.dataset.prod) + '</strong>';
      var old = player.querySelector('iframe'); if (old) old.remove();
      if (play) playNow();
    }
    function playNow() {
      if (!cur || !cur.dataset.yt) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(cur.dataset.yt) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = cur.dataset.title; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;z-index:3';
      player.appendChild(f);
    }
    root.addEventListener('click', function (e) {
      var c = e.target.closest('.t-chap'); if (c) { select(c, true); return; }
      if (e.target.closest('[data-t-play]')) playNow();
    });
  }

  // ---------- Journal topic filter ----------
  function initJournal(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.t-topics button'); if (!b) return;
      root.querySelectorAll('.t-topics button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      // "All": the newest 5; a topic: up to 5 matching articles, or a short note with a link when none match (Codex review 30.10.2026)
      var shown = 0, all = b.dataset.t === 'all';
      root.querySelectorAll('.t-post').forEach(function (p) {
        var ok = all ? !p.hasAttribute('data-t-extra') : (' ' + p.dataset.t + ' ').indexOf(' ' + b.dataset.t + ' ') !== -1 && shown < 5;
        p.hidden = !ok; if (ok) shown++;
      });
      var none = root.querySelector('[data-t-none]');
      if (!none) { none = document.createElement('p'); none.setAttribute('data-t-none', ''); none.style.cssText = 'margin:8px 0 0;color:var(--ink-muted)'; root.querySelector('.t-posts').after(none); }
      none.hidden = shown > 0;
      if (!shown) { var all_a = root.querySelector('.t-journal-head a'); none.innerHTML = 'No articles on this topic yet. <a href="' + (all_a ? all_a.getAttribute('href') : '/blogs/news') + '">See all articles</a>'; }
    });
  }

  // ---------- Copy email, newsletter stage tag, welcome pop-up ----------
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-t-copy]'); if (!c) return;
    var done = function () { c.textContent = 'Copied'; setTimeout(function () { c.textContent = 'Copy'; }, 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(c.dataset.tCopy).then(done, done); else done();
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-t-stage]'); if (!s) return;
    var tags = s.form && s.form.querySelector('[data-t-tags]'); if (!tags) return;
    var base = tags.value.split(',').filter(function (t) { return t.indexOf('stage-') !== 0; });
    if (s.value) base.push('stage-' + s.value.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
    tags.value = base.join(',');
  });
  function initPop() {
    var pop = document.querySelector('[data-t-pop]'), tab = document.querySelector('[data-t-pop-open]');
    if (!pop) return;
    var KEY = 'ttt-pop-seen', seen = false; try { seen = !!localStorage.getItem(KEY); } catch (e) {}
    var posted = /customer_posted=true/.test(location.search) && location.hash.indexOf('t-pop-form') !== -1;
    function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('t-in'); }); if (tab) tab.hidden = true; }
    function close() { pop.classList.remove('t-in'); setTimeout(function () { pop.hidden = true; }, 300); try { localStorage.setItem(KEY, '1'); } catch (e) {} if (tab) tab.hidden = false; }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-t-pop-close]') || e.target === pop) close();
      if (e.target.closest('[data-t-pop-open]')) open();
    });
    if (posted) { open(); return; }
    if (seen) { if (tab) tab.hidden = false; return; }
    if (/^\/(cart|checkouts?)\b/.test(location.pathname)) { if (tab) tab.hidden = false; return; }   // never interrupt the basket
    // Codex UX review 30.10.2026: the full-screen pop-up interrupted filtering. On phones it never opens by itself (the
    // small 10% tab is shown instead), and on collection / search pages it does not open by itself on any device.
    var phone = window.matchMedia('(max-width: 640px)').matches;
    if (phone || /^\/(collections|search)\b/.test(location.pathname)) { if (tab) tab.hidden = false; return; }
    var fired = false;
    var bannerGoneAt = 0;
    function bannerOn() {   // the cookie banner is position:fixed, so offsetParent is always null: check its box instead (29.10.2026)
      var cb = document.getElementById('shopify-pc__banner');
      if (!cb) return false;
      var cs = getComputedStyle(cb), r = cb.getBoundingClientRect();
      return cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0 && r.width > 0 && r.height > 0;
    }
    function blocked() {   // cookie banner on screen (or closed less than 10 s ago), or a header panel / menu open
      if (bannerOn()) { bannerGoneAt = 0; return true; }
      if (document.getElementById('shopify-pc__banner') && !bannerGoneAt) bannerGoneAt = Date.now();
      if (bannerGoneAt && Date.now() - bannerGoneAt < 10000) return true;
      return !!document.querySelector('.t-drop:not([hidden])');
    }
    function fire() { if (fired) return; if (blocked()) { setTimeout(fire, 2000); return; } fired = true; open(); }
    setTimeout(fire, 35000);
    window.addEventListener('scroll', function () { if (window.scrollY > (document.body.scrollHeight - innerHeight) * 0.5) fire(); }, { passive: true });
    if (window.matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });   // exit intent (desktop)
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ttt="launch"]').forEach(initLaunch);
    (scope || document).querySelectorAll('[data-ttt="finder"]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-t-ann]').forEach(initAnn);
    (scope || document).querySelectorAll('.t-header-wrap').forEach(initHeader);
    (scope || document).querySelectorAll('[data-ttt="stages"]').forEach(initStages);
    (scope || document).querySelectorAll('[data-ttt="video"]').forEach(initVideo);
    (scope || document).querySelectorAll('[data-ttt="journal"]').forEach(initJournal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); initPop(); });
  else { boot(); initPop(); }
  // Re-initialise when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ---------- Terms agreement before checkout (replaces the TnC Terms Checkbox app, 25.10.2026) ----------
   Ticking the box records the acceptance with a timestamp (evidence for chargebacks):
   - cart page: cart attributes -> order "Additional details" in admin
   - product page (express Buy now): hidden line item properties in the product form
   Locked buttons are handled in CSS; here we only record, guard clicks/submits and send popup "Checkout" to the basket. */
(function () {
  function ukTime(d) {
    try { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', dateStyle: 'medium', timeStyle: 'long' }).format(d); }
    catch (e) { return d.toString(); }
  }
  function record(cb) {
    var box = cb.closest('[data-t-terms]'); if (!box) return Promise.resolve();
    var saved = Promise.resolve();
    var mode = box.getAttribute('data-t-terms'), ver = box.getAttribute('data-terms-version') || 'current';
    var now = new Date(), on = cb.checked;
    if (mode === 'cart' || mode === 'product') {
      var attrs = on ? {
        'Terms accepted': 'Yes - Terms of Service, Returns Policy and Privacy Policy',
        'Terms accepted at (UTC)': now.toISOString(),
        'Terms accepted at (UK)': ukTime(now),
        'Terms version': ver,
        'Terms accepted on': location.host + location.pathname
      } : { 'Terms accepted': '', 'Terms accepted at (UTC)': '', 'Terms accepted at (UK)': '', 'Terms version': '', 'Terms accepted on': '' };
      saved = fetch('/cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    }
    if (mode === 'product') {
      box.querySelectorAll('[data-t-terms-prop]').forEach(function (inp) {
        var k = inp.getAttribute('data-t-terms-prop');
        if (k === 'utc') inp.value = on ? now.toISOString() : '';
        if (k === 'uk') inp.value = on ? ukTime(now) : '';
        inp.disabled = !on;
      });
    }
    var msg = box.querySelector('[data-t-terms-msg]'); if (msg && on) msg.hidden = true;
    if (on) box.classList.remove('t-terms-need');
    return saved;
  }
  function blocked(scope) {
    var cb = scope && scope.querySelector('[data-t-terms-cb]');
    if (!cb || cb.checked) return false;
    var msg = scope.querySelector('[data-t-terms-msg]'); if (msg) msg.hidden = false;
    var box = cb.closest('[data-t-terms]'); if (box) { box.classList.add('t-terms-need'); box.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    cb.focus({ preventScroll: true }); return true;
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-t-terms-cb]')) record(e.target); });
  /* clicks on locked express buttons (their wrapper ignores pointer events, so the click lands on the scope) and on checkout */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var toCart = t.closest && t.closest('[data-t-to-cart]');
    if (toCart) { e.preventDefault(); location.href = '/cart'; return; }
    var scope = t.closest && t.closest('[data-t-terms-scope]'); if (!scope) return;
    var locked = t.closest('.t-cart-xpay, .tp-xp-paypal, .tp-xp') || t.closest('button[name="checkout"]');
    if (!locked) return;
    if (blocked(scope)) { e.preventDefault(); e.stopPropagation(); return; }
    /* box already ticked (possibly in an earlier visit): stamp the acceptance again at the moment of checkout.
       For the checkout button we wait for the cart update, otherwise the checkout is created with the old stamp. */
    var cb = scope.querySelector('[data-t-terms-cb]'); if (!cb || !cb.checked) return;
    var btn = t.closest('button[name="checkout"]');
    if (!btn) { record(cb); return; }
    if (btn.hasAttribute('data-t-stamped')) return;
    e.preventDefault(); e.stopPropagation();
    record(cb).then(function () {}, function () {}).then(function () {
      btn.setAttribute('data-t-stamped', '');
      var f = btn.form;
      if (f && f.requestSubmit) f.requestSubmit(btn); else btn.click();
    });
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') {
      var scope = sub.closest('[data-t-terms-scope]') || document.querySelector('[data-t-terms-scope]');
      if (blocked(scope)) e.preventDefault();
    }
  }, true);
  /* product page: keep the hidden properties in step with a box that was ticked before a re-render */
  document.querySelectorAll('[data-t-terms="product"] [data-t-terms-cb]').forEach(function (cb) { if (cb.checked) record(cb); });
})();

/* Homepage analytics (owner 29.10.2026, Codex point 7): which blocks people click and how far they scroll, sent to GA4.
   Events: home_block_click {block, link_text, link_url, position} and home_scroll {percent: 25/50/75/100}.
   gtag only exists after cookie consent, so nothing is sent without it. */
(function () {
  'use strict';
  if (location.pathname !== '/') return;
  var NAMES = { t_announcement: 'announcement', t_header: 'header', t_launch: 'just_launched', t_categories: 'categories', t_popular: 'popular',
    t_finder: 'seat_finder', t_newin: 'new_in', t_stages: 'stages', t_brands: 'brands', t_video: 'video', t_preorder: 'new_launches',
    t_reviews: 'reviews', t_journal: 'journal', t_ask: 'ask_us', t_footer: 'footer' };
  function send(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ transport_type: 'beacon' }, params));
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href], button');
    var sec = a && a.closest('[id^="shopify-section-"]');
    if (!sec) return;
    var key = sec.id.split('__').pop();
    var links = Array.prototype.slice.call(sec.querySelectorAll('a[href], button'));
    send('home_block_click', {
      block: NAMES[key] || key,
      link_text: (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      link_url: a.tagName === 'A' ? a.getAttribute('href').slice(0, 120) : '(button)',
      position: links.indexOf(a) + 1
    });
  }, true);
  var marks = [25, 50, 75, 100], sent = {};
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var pct = (window.scrollY / h) * 100;
    marks.forEach(function (m) { if (!sent[m] && pct >= m - 1) { sent[m] = true; send('home_scroll', { percent: m }); } });
    if (sent[100]) window.removeEventListener('scroll', onScroll);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
